import { useIntl } from 'react-intl'
import { matchPath, useLocation } from 'react-router'
import { getRoutesData } from '../PrivateContent'

// некоторые роуты могут пересекаться по названию и  нуждаются в полной проверке, другие наоборот в проверке на startsWith
const exactRoutes = [
  '/reports-summary',
  '/requests-archive',

  '/service-reports/:reportId',
  '/reports/:reportId',

  '/requests/:requestId',
  '/service/:serviceRequestId',

  '/service-reports/create',
  '/service-reports/:reportId/add',

  '/reports/create',
  '/reports/:reportId/add',

  '/customers/:customerId',
]

export const useRouteTitle = () => {
  const location = useLocation()
  const intl = useIntl()
  const routesData = getRoutesData(intl)

  const routeObj = routesData.find((el) => {
    if (el.path === '/') {
      return false
    }

    const isExactRoute = exactRoutes.some((route) =>
      matchPath({ path: route }, location.pathname),
    )

    const isSameRoute =
      isExactRoute && el?.path
        ? !!matchPath({ path: el?.path }, location.pathname)
        : location.pathname.startsWith(el.path)

    return el?.path && !!isSameRoute
  })

  return getTitle(routeObj)
}

const getTitle = (routeObj: any) => {
  if (routeObj) {
    if (routeObj.children) {
      return {
        title: routeObj.children[0].pageTitle,
        // @ts-ignore
        href: window.SAT.config?.wikiLinks?.[routeObj.children[0]?.path] ?? '',
      }
    } else {
      return {
        title: routeObj.pageTitle,
        // @ts-ignore
        href: window.SAT.config?.wikiLinks?.[routeObj?.path] ?? '',
      }
    }
  } else {
    return ''
  }
}
